import axios from '../utils/bureauRequest'

import requestHeader from '../utils/requestHeader'

const bureauAxios = (url, methodType, params, options, isShowErrorNotify) => {
  axios.defaults.withCredentials = true
  if (typeof isShowErrorNotify === 'undefined') {
    isShowErrorNotify = true
  }

  //redirectLogin: 当http 401或者response.code=401则跳转到学校登录页
  let request = {
    url: url,
    method: methodType,
    headers: requestHeader.createHeaders(params),
    showErrorNotify: isShowErrorNotify,
    redirectLogin: true,
  }
  if (options != null) {
    for (let key in options) {
      request[key] = options[key]
    }
  }

  if (params != null) {
    var formData = null
    for (let key in params) {
      //如果有文件，则使用FormData
      if (params[key] instanceof File) {
        formData = new FormData()
        break
      }
    }
    if (formData == null) {
      //非文件上传操作使用URLSearchParams
      formData = new URLSearchParams()
    }
    for (let key in params) {
      formData.append(key, params[key])
    }
    //如果是post请求，以formdata的形式传递
    if (methodType.toUpperCase() == 'GET') request.params = formData
    else request.data = formData
  }
  return axios(request)
}


export { bureauAxios }
